import * as Yup from 'yup';

import { EIV_CHAR_LENGTH, VALIDATION_CONSTANTS } from 'global/constants';

import { YParticipant } from './YParticipant';

export const DUPLICATE_PARTICIPANT_EMAIL = 'E-Mail-Adresse wird bereits verwendet';

const validateUniqueParticipantEmails = function validateUniqueParticipantEmails(participants) {
  if (!participants?.length) {
    return true;
  }

  const emailToIndexes = new Map();

  participants.forEach((participant, index) => {
    const email = (participant?.eMail || '').trim().toLowerCase();
    if (!email) {
      return;
    }

    if (!emailToIndexes.has(email)) {
      emailToIndexes.set(email, []);
    }
    emailToIndexes.get(email).push(index);
  });

  const errors = [];

  emailToIndexes.forEach((indexes) => {
    if (indexes.length < 2) {
      return;
    }

    const indexToError = indexes[indexes.length - 1];

    errors.push(
      this.createError({
        path: `participants[${indexToError}].eMail`,
        message: DUPLICATE_PARTICIPANT_EMAIL,
      })
    );
  });

  if (errors.length) {
    throw new Yup.ValidationError(errors);
  }

  return true;
};

export const YEventRegistration = Yup.object().shape({
  firmenname1: Yup.string()
    .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
    .max(EIV_CHAR_LENGTH.FIRMENNAME1, VALIDATION_CONSTANTS.TOO_LONG)
    .required(VALIDATION_CONSTANTS.MANDATORY),
  firmenname2: Yup.string()
    .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
    .max(EIV_CHAR_LENGTH.FIRMENNAME2, VALIDATION_CONSTANTS.TOO_LONG),
  firmenname3: Yup.string()
    .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
    .max(EIV_CHAR_LENGTH.FIRMENNAME3, VALIDATION_CONSTANTS.TOO_LONG),
  participants: Yup.array(YParticipant).test(
    'unique-participant-emails',
    DUPLICATE_PARTICIPANT_EMAIL,
    validateUniqueParticipantEmails
  ),
});
